import React from 'react';
import styled from 'styled-components';

const Card = styled.div``

const Header = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 20px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  color: #565656;
  font-size: 14px;
  gap: 15px;
`

const Section = styled.div`
  display: flex;
`

const SectionHeader = styled.div`
  width: 80px;
  color: #080808;
  font-size: 15px;
  min-width: 80px;
`

const SectionCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
`

export default ({
  opportunity
}) => {
  const {
    //CloseDate, 
    //Created_Date_Formula__c,
    Site_Type__c,
    //Tracking_Email_Is_Sent__c
  } = opportunity

  return (
    <Card>
      <Header>
        {'Details'}
      </Header>
      <Body>
        {/*
        <Section>
          <SectionHeader>{'Created'}</SectionHeader>
          <SectionCol>
            <div>{Created_Date_Formula__c}</div>
          </SectionCol>
        </Section>
        <Section>
          <SectionHeader>{'Closed'}</SectionHeader>
          <SectionCol>
            <div>{CloseDate}</div>
          </SectionCol>
        </Section>
         */}
        <Section>
          <SectionHeader>{'Site Type'}</SectionHeader>
          <SectionCol>
            <div>{Site_Type__c}</div>
          </SectionCol>
        </Section>
        {/*
        <Section>
          <SectionHeader>{'Emails'}</SectionHeader>
          <SectionCol>
            <div>{Tracking_Email_Is_Sent__c ? 'Order Created' : ''}</div>
          </SectionCol>
        </Section>
         */}
      </Body>
    </Card>
  )
}